var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';

import GithubMarkRegular from '../images/GitHub-Mark-32px.png';
import GithubMarkLight from '../images/GitHub-Mark-Light-32px.png';

var _default = function (_Component) {
  _inherits(_default, _Component);

  function _default() {
    _classCallCheck(this, _default);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  _default.prototype.render = function render() {
    var position = this.props.position || 'bottom-right';
    var padding = this.props.padding || '8px-8px';
    var GithubMark = GithubMarkRegular;
    if (this.props.light) {
      GithubMark = GithubMarkLight;
    }

    var propSplitRegExp = /([^-]+)-([^-]+)/;
    var parsedPosition = position.match(propSplitRegExp);
    var parsedPadding = padding.match(propSplitRegExp);

    var styleProps = {};

    if (parsedPosition && parsedPadding) {
      styleProps[parsedPosition[1]] = parsedPadding[1];
      styleProps[parsedPosition[2]] = parsedPadding[2];
    }

    return React.createElement(
      'div',
      null,
      React.createElement(
        'a',
        {
          href: this.props.href,
          style: _extends({}, styleProps, {
            zIndex: '9999',
            position: 'fixed',
            width: '32px',
            height: '32px'
          })
        },
        React.createElement('img', { src: GithubMark, alt: 'GitHub' })
      )
    );
  };

  return _default;
}(Component);

export { _default as default };


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-github-mark/es/index.js
// module id = 118
// module chunks = 0